
import axios from 'axios';
import { saveAs } from 'file-saver';
// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
  CONTRACT_STUDENT_ACTION,
  CONTRACT_ALL_STUDENT,
  DETAILS_ID_CARD,
  DOWNLOAD_STUDENT_CARD,
  UPLOAD_STUDENT_IMAGE
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';

export const contractAllStudentID = () => {
  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios.get(AppConfig.apiurl + '/api/getctstudents', { headers: AuthHeader.header })
      .then(response => {
        const alldata = response.data.data;
        dispatch({ type: CONTRACT_ALL_STUDENT, payload: alldata });
      });
  };
};


export const detailsIDCard = (id) => async (dispatch) => {

  var payload = {
    "id": id

  }
  dispatch({ type: CONTRACT_STUDENT_ACTION });
  return axios.post(AppConfig.apiurl + '/api/detailsforIDcard', payload, { headers: AuthHeader.header })
    .then(response => {
      var resdata = response.data;
      var resvalue = resdata.data;
      dispatch({ type: DETAILS_ID_CARD, payload: resvalue });
      return Promise.resolve(resdata);

    })
    .catch(error => {
      const errormsg = error.message
      NotificationManager.error(errormsg);
    });

}

export const studentDetailsIDCard = (id) => async (dispatch) => {

      var payload = {
        "id": id
      }
      dispatch({ type: CONTRACT_STUDENT_ACTION });
      return axios.post(AppConfig.apiurl + '/api/studentdetailsforIDcard', payload, { headers: AuthHeader.header })
        .then(response => {
          var resdata = response.data;
          var resvalue = resdata.data;
          dispatch({ type: DETAILS_ID_CARD, payload: resvalue });
          return Promise.resolve(resdata);

        })
        .catch(error => {
          const errormsg = error.message
         
        });

}

export const downloadStudentCard = (id) => {
  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    const downloadUrl = `${AppConfig.apiurl}/api/studentidcardpdf/${id}`;
    axios
      .get(downloadUrl, { headers: AuthHeader.header, responseType: 'blob' })
      .then(response => {
        const blobUrl = URL.createObjectURL(response.data);
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = 'student_card.pdf';
        anchor.click();
        dispatch({ type: DOWNLOAD_STUDENT_CARD, payload: id });
      })
      .catch(error => {
        console.error('Error occurred while downloading the PDF:', error);
      });
  };
};


export const uploadStudentImage = (id, studimage) => async (dispatch) => {
  var payload = {
    "studentid": id,
    "studimage":studimage
  }
  dispatch({ type: CONTRACT_STUDENT_ACTION });
  axios.post(AppConfig.apiurl + '/api/uploadstudentphoto', payload, { headers: AuthHeader.header })
  .then(response => {
    const alldata = response.data.data;
    dispatch({ type: UPLOAD_STUDENT_IMAGE, payload: alldata });
  });
}

